import React, { useRef } from 'react';
import FloatingMenu from '../FloatingMenu';
import limitationsImg from '../../assets/images/limitations.svg';
import challengesImg from '../../assets/images/challenges.svg';
import futureImg from '../../assets/images/future.svg';
import '../styles/ChallengesNext.css';

const ChallengesNext = () => {
  const cardsContainerRef = useRef(null);
  
  // Function to handle scrolling left and right
  const scrollCards = (direction) => {
    if (cardsContainerRef.current) {
      const container = cardsContainerRef.current;
      const scrollAmount = direction === 'left' ? -300 : 300;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="page-section challenges-container">
      <FloatingMenu />
      <h1 className="challenges-header">
        <span className="emoji">🚀</span>
        Limitations & Future Work
      </h1>
      
      {/* Enhanced scroll indicator */}
      <div className="scroll-indicator">
        <span>← Swipe to see all cards →</span>
      </div>
      
      {/* Scroll navigation arrows */}
      <div className="scroll-arrows scroll-left" onClick={() => scrollCards('left')}>
        ←
      </div>
      <div className="scroll-arrows scroll-right" onClick={() => scrollCards('right')}>
        →
      </div>
      
      <div className="cards-container" ref={cardsContainerRef}>
        {/* Current Limitations Card */}
        <div className="challenge-card">
          <div className="card-image-container">
            <img src={limitationsImg} alt="Current Limitations" className="card-image" />
          </div>
          <div className="card-content">
            <h2 className="card-subheader">Current Limitations</h2>
            <p className="card-paragraph">
              While Chefbelle is functional, we acknowledge several limitations that we're actively working to address:
            </p>
            <ul className="card-list">
              <li className="card-list-item">Hallucination remains possible despite RAG implementation</li>
              <li className="card-list-item">Tool reliability depends on external APIs</li>
              <li className="card-list-item">Context window limits very long conversations</li>
              <li className="card-list-item">Prototype does not yet connect to a live backend (Still in notebook version, and needed to be developed.)</li>
              <li className="card-list-item">Limited recipe and nutrition dataset (expandable)</li>
              <li className="card-list-item">Mobile and accessibility optimizations in progress</li>
            </ul>
          </div>
        </div>
        
        {/* Development Challenges Card */}
        <div className="challenge-card">
          <div className="card-image-container">
            <img src={challengesImg} alt="Development Challenges" className="card-image" />
          </div>
          <div className="card-content">
            <h2 className="card-subheader">Development Challenges</h2>
            <p className="card-paragraph">
              The development journey of Chefbelle was both rewarding and challenging, pushing our technical and creative boundaries:
            </p>
            <ul className="card-list">
              <li className="card-list-item">It was a fun but time-constrained project with ambitious goals</li>
              <li className="card-list-item">The work was intensive with potential for further refinement</li>
              <li className="card-list-item">Balancing technical complexity with user experience requirements</li>
              <li className="card-list-item">Integrating multiple technologies and ensuring seamless data flow</li>
              <li className="card-list-item">Optimizing performance across different use cases and scenarios</li>
            </ul>
          </div>
        </div>
        
        {/* Future Work Card */}
        <div className="challenge-card">
          <div className="card-image-container">
            <img src={futureImg} alt="Future Work" className="card-image" />
          </div>
          <div className="card-content">
            <h2 className="card-subheader">Future Work</h2>
            <p className="card-paragraph">
              We have ambitious plans to enhance Chefbelle with innovative features and improvements:
            </p>
            <ul className="card-list">
              <li className="card-list-item">Pantry inventory integration to track available ingredients</li>
              <li className="card-list-item">Multi-modal image input for ingredients identification</li>
              <li className="card-list-item">Proactive suggestions based on expiring items</li>
              <li className="card-list-item">Advanced personalization based on user preferences and dietary needs</li>
              <li className="card-list-item">Interactive dashboards for meal planning and nutrition tracking</li>
              <li className="card-list-item">Web scraping from food.com and other recipe sites to expand database</li>
              <li className="card-list-item">Regularly updating vectorized and SQL databases with better recipes</li>
              <li className="card-list-item">Adding options for online purchase of ingredients</li>
              <li className="card-list-item">Referrals to local markets for ingredient shopping</li>
              <li className="card-list-item">Integration with actual LangGraph backend for real-time agent responses</li>
              <li className="card-list-item">Mobile app version and improved accessibility features</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengesNext;
